/* src/app/coupons/add-coupon/add-coupon.component.scss */
.add-coupon-container {
  border: 1px solid #949494;
  border-radius: 20px;
  padding: 8px 8px 8px 16px;
}
.hide-input {
  visibility: hidden;
  height: 0px;
}
.cupon-code {
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
}
ion-item::part(native) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.coupon-code-input ::ng-deep .native-input {
  color: black;
  font-weight: 900;
  font-size: 22px;
  text-transform: uppercase;
}
.coupon-code-input ::ng-deep .native-input::placeholder {
  color: #949494;
  font-size: 18px;
  font-weight: 400 !important;
  text-transform: none;
}
.couponDisabledMessage {
  font-family: "Barlow Semi Condensed", sans-serif;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: var(--ion-color-danger);
  z-index: 9;
  font-weight: bold;
  width: 90%;
  font-size: 18px;
}
.cupon-code-valid {
  font-weight: 900;
  font-size: 1.3rem;
  text-transform: uppercase;
  font-family: "Arial Black", sans-serif;
}
.apply-button {
  --background: #f6f6f6;
  --background-hover: #f9f9f9;
  --background-activated: #eeeeee;
  --border-radius: 15px;
  color: black;
  font-weight: 500;
  font-size: 18px;
  margin: 0;
}
@media (max-width: 1024px) {
  .apply-button {
    --border-radius: 5px;
    min-height: 0;
  }
  .apply-button::part(native) {
    padding: 10px 12px 10px 12px;
  }
  .coupon-code-input {
    padding-right: 0;
  }
  .coupon-code-input ::ng-deep .native-input {
    color: black;
    font-weight: 900;
    font-size: 22px;
    text-transform: uppercase;
  }
  .coupon-code-input ::ng-deep .native-input::placeholder {
    color: #949494;
    font-size: 16px;
    font-weight: 400 !important;
    text-transform: none;
  }
  .couponDisabledMessage {
    font-size: 16px;
  }
}
.remove-coupon ion-text {
  color: #0c8ce9;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
}
.remove-coupon ion-button {
  --background: #f6f6f6;
  --background-hover: #f9f9f9;
  --background-activated: #eeeeee;
  --border-radius: 15px;
  font-weight: 500;
  font-size: 18px;
  color: #eb445a;
  margin: 0;
}
/*# sourceMappingURL=add-coupon.component-L3J7HE6I.css.map */
